const SUCCESS_STORIES_LOADING = 'SUCCESS_STORIES_LOADING';
const GET_SUCCESS_STORIES = 'SUCCESS_STORIES_DETAILS';
const GET_PARTNER_DETAIL = 'GET_PARTNER_DETAIL';
const SET_TRANSLATION_TEXT = 'SET_TRANSLATION_TEXT';
const ACTIONS_TYPE = {
  SUCCESS_STORIES_LOADING,
  GET_SUCCESS_STORIES,
  GET_PARTNER_DETAIL,
  SET_TRANSLATION_TEXT,
};
export default ACTIONS_TYPE;
